const attributes = {
  count: 'data-cart-count',
  limit: 'data-limit',
};

let cartCountRequest = null;

function fetchCartCount() {
  if (!cartCountRequest) {
    const root = window.Shopify?.routes?.root || '/';

    cartCountRequest = fetch(`${root}cart.js`, {
      cache: 'no-store',
      credentials: 'same-origin',
      headers: {Accept: 'application/json'},
    })
      .then((response) => (response.ok ? response.json() : Promise.reject(response)))
      .then((cart) => cart.item_count)
      .finally(() => {
        cartCountRequest = null;
      });
  }

  return cartCountRequest;
}

class CartCount extends HTMLElement {
  constructor() {
    super();

    this.cartCount = null;
    this.limit = this.getAttribute(attributes.limit);
    this.changeVersion = 0;
    this.onCartChangeCallback = this.onCartChange.bind(this);
    this.onPageShowCallback = this.onPageShow.bind(this);
  }

  connectedCallback() {
    document.addEventListener('theme:cart:change', this.onCartChangeCallback);
    window.addEventListener('pageshow', this.onPageShowCallback);
  }

  disconnectedCallback() {
    document.removeEventListener('theme:cart:change', this.onCartChangeCallback);
    window.removeEventListener('pageshow', this.onPageShowCallback);
  }

  onPageShow() {
    this.refresh();
  }

  async refresh() {
    const versionAtStart = this.changeVersion;

    try {
      const count = await fetchCartCount();


      if (this.changeVersion !== versionAtStart) return;

      this.cartCount = count;
      this.update();
    } catch (error) {
    }
  }

  onCartChange(event) {
    if (event.detail.cartCount === undefined) return;

    this.changeVersion += 1;
    this.cartCount = event.detail.cartCount;
    this.update();
  }

  update() {
    if (this.cartCount !== null) {
      this.setAttribute(attributes.count, this.cartCount);
      let countValue = this.cartCount;

      if (this.limit && this.cartCount >= Number(this.limit)) {
        countValue = '9+';
      }

      if (this.closest('.cart__total--total')) {
        this.innerText = `(${countValue} items)`;
      } else {
        this.innerText = countValue;
      }
    }
  }
}

if (!customElements.get('cart-count')) {
  customElements.define('cart-count', CartCount);
}
